import React from 'react';
import { LangContext } from '../contexts/lang.context';
import { DispatchContext } from '../contexts/userInfo.context';
import { useInputState } from '../hooks/useInputState';
import { HintText, SectionTitle, MyButton, MyTextField } from './ui';
import { ActionTypes } from '../actions';
import { parsePhoneNumberFromString, PhoneNumber, CountryCode } from 'libphonenumber-js';
import { CountryCodesMenuItems } from './CountryCodesMenuItems';
import * as model from '../models/api';

export const LoginSection: React.FC = () => {
  const { LOGIN_SECTION, ALERT, BUTTON } = React.useContext(LangContext).currentLangData;
  const dispatch = React.useContext(DispatchContext);

  const [loginId, setLoginId, handleChange] = useInputState('');
  const [countryCode, setCountryCode] = React.useState<CountryCode>('TW');
  const [isProgress, setIsProgress] = React.useState(false);
  const [isEmpty, setIsEmpty] = React.useState(false);
  const [isValidNumber, setIsValidNumber] = React.useState<boolean | null>(null);

  const handleCountryChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setCountryCode(event.target.value as CountryCode);
  };

  const handleIdSubmit = async () => {
    try {
      // Check if the TextField is empty
      if (loginId.length === 0) {
        setIsEmpty(true);
        return;
      }
      setIsEmpty(false);

      // Get the parsed phone number: [CountryCode] + [Phone Number]
      const phoneNumber: PhoneNumber | undefined = parsePhoneNumberFromString(loginId, countryCode);
      if (phoneNumber === undefined) {
        alert(ALERT.undefinedPhoneNumber);
        return;
      }

      console.log(phoneNumber);

      // Check the validity of the input phone number
      if (!phoneNumber.isValid()) {
        setIsValidNumber(false);
        return;
      }
      setIsValidNumber(true);

      // Now, the input is valid, so start fetching the user info
      setIsProgress(true);

      // Change the display phone number
      setLoginId(phoneNumber.nationalNumber as string);

      // Use the formatted [CountryCode] + [Phone Number] to login
      const userInfo = await model.login(phoneNumber.number as string);
      if (userInfo === undefined) {
        alert(ALERT.loginFail);
        return;
      }

      // Login success, so update the context by dispatching
      console.log('login success\n userInfo: \n' + JSON.stringify(userInfo, null, 2));
      dispatch({ type: ActionTypes.fetchUserInfo, payload: userInfo });

      // Fetch statistics
      if (userInfo.statistics === undefined) {
        userInfo.statistics = await model.getStatistics();
        if (userInfo.statistics === undefined) {
          // todo: handle fail
          return;
        }
        console.log('getStatistics success\n userInfo: \n' + JSON.stringify(userInfo, null, 2));
        dispatch({
          type: ActionTypes.fetchUserInfo,
          payload: { ...userInfo },
        });
      }
    } catch (error) {
      console.log(error);
      alert(ALERT.loginFail);
    } finally {
      setIsProgress(false);
    }
  };

  return (
    <>
      <HintText text={LOGIN_SECTION.hint} />
      <SectionTitle title={LOGIN_SECTION.title} />
      <CountryCodesMenuItems countryCode={countryCode} handleCountryChange={handleCountryChange} />
      <MyTextField
        text={loginId}
        placeholder={LOGIN_SECTION.placeholder}
        warning={isEmpty ? LOGIN_SECTION.emptyWarning : LOGIN_SECTION.invalidWarning}
        isError={(isEmpty && loginId.length === 0) || isValidNumber === false}
        onChange={handleChange}
        onEnterPress={handleIdSubmit}
      />

      <MyButton
        isProgress={isProgress}
        onClick={handleIdSubmit}
        text={isProgress ? BUTTON.loading : BUTTON.login}
      />
    </>
  );
};
